var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MutedOutlined, SoundOutlined } from '@ant-design/icons';
import { boopScanRegistered, setScanSoundEnabled } from './audioFeedback';
var storageKey = function () { return "packingScanSound:" + (localStorage.getItem('userId') || 'anon'); };
var readStoredPreference = function () {
    try {
        return localStorage.getItem(storageKey()) !== '0'; // default on
    }
    catch (_a) {
        return true;
    }
};
export var SoundToggleButton = function () {
    var t = useTranslation().t;
    var _a = useState(readStoredPreference), enabled = _a[0], setEnabled = _a[1];
    // push the persisted preference into the audio module on mount
    useEffect(function () {
        setScanSoundEnabled(enabled);
    }, [enabled]);
    var toggle = function () {
        var next = !enabled;
        setEnabled(next);
        setScanSoundEnabled(next);
        try {
            localStorage.setItem(storageKey(), next ? '1' : '0');
        }
        catch (_a) {
            // noop
        }
        if (next)
            boopScanRegistered();
    };
    return (_jsx("button", __assign({ type: 'button', onClick: toggle, className: "flex items-center justify-center rounded-lg border p-2 leading-none transition-colors sm:px-4 " + (enabled
            ? 'border-gray-200 bg-white text-gray-500 hover:bg-gray-50'
            : 'border-red-200 bg-red-50 text-red-600 hover:bg-orange-100'), title: (enabled ? t('Scan sounds on') : t('Scan sounds muted')) }, { children: enabled ? _jsx(SoundOutlined, { style: { fontSize: 14 } }, void 0) : _jsx(MutedOutlined, { style: { fontSize: 14 } }, void 0) }), void 0));
};
export default SoundToggleButton;
